import React, { PureComponent } from 'react';
import { renderStartEndLocation, renderTimeDate  } from '../../../../helpers/cyoaHelper';
import _filter from 'lodash/filter';
import Toggle from 'react-toggle'
import dayjs from 'dayjs';
import ResponsiveImage from '../../../shared/responsiveImage';
import { CYOA_NETWORK_IDS } from '../../../../config';


class TripInfoView extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      toggleCheck:false
    }
    this.handleToggleChange = this.handleToggleChange.bind(this);
  }

  handleToggleChange(){
    this.setState({toggleCheck: !this.state.toggleCheck});
  }

  render(){

    const { toggleCheck } = this.state;
    const { index, sectors, cities, active } = this.props;
    
    const activeCity = _filter(cities, ['name', active]);
    const activeSectors = _filter(sectors, ['name', active]);

    const imageLink = _filter(activeCity[0].images, {'title': 'hero'})[0] === undefined ? "" : _filter(activeCity[0].images, {'title': 'hero'})[0].url;
    const mapLink = `https://api.mapbox.com/styles/v1/ken-busabout/cjm91nhzo0cji2rnyd5jx50g4/static/${activeCity[0].long},${activeCity[0].lat},6.0,0,0/600x600?access_token=${process.env.REACT_APP_MAPBOX_API_TOKEN}`;


    return (
      <div className="tripinfo-view" style={{display:activeCity[0].address === null ? "none" : "block"}}>
        <div className="row">
          <div className="column small-12 medium-6">
            <p className="no-margin grey-subtile-text">{ activeCity[0].address === null ? "" : activeCity[0].address.replace("__", "").replace("__", " -") }</p>
            <h5 className="busabout-h5 no-margin">{activeCity[0].name}</h5>

            <div className="row">
              <div className="column medium-6">
                <p className="no-margin orange-text bold">{activeSectors[0].duration} nights</p>
              </div>

              <div className="column medium-6">
                <p className="no-margin bold text-right">
                  {`${dayjs(sectors[index].transfer.start_arrival_date).format("DD MMMM")}`} 

                  <span style={{display: sectors[index].transfer.end_departure_date !== null ? 'inline' : 'none' }}>
                    {` - ${dayjs(sectors[index].transfer.end_departure_date).format("DD MMMM")}`}
                  </span>
                </p>
              </div>
            </div>


            <ul style={{display: (index === sectors.length - 1) ? 'none' : 'block' }}>
              <li>
                <div className="white-background"><span className="ba-icon ba-icon-pickup2"></span></div>
                <p className="bold">{(activeSectors[0].tour_id === CYOA_NETWORK_IDS["europe"].id || activeSectors[0].tour_id === CYOA_NETWORK_IDS["usa"].id) ? `Drop-off location in ${activeSectors[0].city}` : 'Start'}</p>
                <p>{ renderStartEndLocation(index, sectors, "start") }</p>
                <p>{ renderTimeDate(sectors, index, 'start') }</p>
              </li>
              <li>
                <div className="white-background"><span className="ba-icon ba_icon_map_location"></span></div>
                <p className="bold title">{ (activeSectors[0].tour_id === CYOA_NETWORK_IDS["europe"].id || activeSectors[0].tour_id === CYOA_NETWORK_IDS["usa"].id) ? 'Pick-up for next stop' : 'End'}</p>
                <p>{ renderStartEndLocation(index, sectors, "end") }</p>
                <p>{ renderTimeDate(sectors, index,'end') }</p>
              </li>
              <li style={{display: (activeSectors[0].tour_id !== CYOA_NETWORK_IDS["europe"].id || activeSectors[0].tour_id !== CYOA_NETWORK_IDS["usa"].id) ? 'none' : 'block'}}>
                <div className="white-background"><span className="ba-icon ba_icon_hoho"></span></div>
                <p className="bold">{activeSectors[0].next_transfer.text}</p>
                <p>{activeSectors[0].next_transfer.sub_text}</p>
              </li>
            </ul>

          </div>
          <div className="column small-12 medium-6">

            <div className="tripinfo-view-wrapper">
              <label>
                <span>Show map</span>
                <Toggle defaultChecked={toggleCheck} onChange={this.handleToggleChange} />
              </label>
              <div className="tripinfo-view-image" style={{display: !toggleCheck ? 'block' : 'none'}}>
                <ResponsiveImage width={698} widthRetina={898} src={imageLink} alt={activeCity[0].name} quality={60} />
              </div>
              <div className="tripinfo-view-map" style={{display: toggleCheck ? 'block' : 'none'}}>
                <img alt="map" src={mapLink} />
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default TripInfoView;



// WEBPACK FOOTER //
// ./src/components/itinerary/city/components/tripInfo-view.js